import OrderStatus from './OrderStatus';
import styles from './StatusDatePanel.module.scss';
import NextOrderLabel from './ScheduledLabels/NextOrderLabel';
import { hasDateStatus, type DateStatus } from '@chewy/chat-library-common';
import cn from 'classnames';

function getDateStatus(dateStatus: DateStatus, isSpecializedDateStatus: boolean, stackDateStatus: boolean) {
    const showDateStatus = hasDateStatus(dateStatus);

    if (!showDateStatus && !stackDateStatus) return null;

    if (!showDateStatus) {
        return (
            // Keeps carousel thumbnails aligned when another card in the same carousel has a date row.
            <div className={`${styles.dateStatusContainer} ${styles.dateStatusPlaceholder}`} aria-hidden="true">
                <span className={styles.dateStatus}>Date status</span>
            </div>
        );
    }

    if (isSpecializedDateStatus) {
        return (
            <div className={styles.dateStatusContainer}>
                <NextOrderLabel message={dateStatus} />
            </div>
        );
    }

    const status = dateStatus?.status ?? '';
    const label = dateStatus?.label ?? '';

    return (
        <div className={styles.dateStatusContainer}>
            <span className={styles.dateStatus}>
                {status ? <span className={styles.dateStatusStatus}>{status}</span> : null}
                {label ? <span className={styles.dateStatusLabel}>{label}</span> : null}
            </span>
        </div>
    );
}

interface StatusDatePanelProps {
    orderStatus: string;
    dateStatus: DateStatus;
    isAutoship?: boolean;
    stackDateStatus?: boolean;
}

export default function StatusDatePanel({
    orderStatus,
    dateStatus,
    isAutoship = false,
    stackDateStatus = false,
}: StatusDatePanelProps) {
    const isSpecializedDateStatus = orderStatus?.toLowerCase?.() === 'delivered' || isAutoship;

    const statusRowClassName = cn(styles.statusRow, {
        [styles.statusRowAutoship]: isAutoship,
        [styles.statusRowStackDateStatus]: stackDateStatus,
    });

    return (
        <div className={statusRowClassName}>
            {orderStatus && <OrderStatus status={orderStatus} />}
            {getDateStatus(dateStatus, isSpecializedDateStatus, stackDateStatus)}
        </div>
    );
}
